import { render, staticRenderFns } from "./RelationShip.vue?vue&type=template&id=7888ab9c&scoped=true"
import script from "./RelationShip.vue?vue&type=script&lang=js"
export * from "./RelationShip.vue?vue&type=script&lang=js"
import style0 from "./RelationShip.vue?vue&type=style&index=0&id=7888ab9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888ab9c",
  null
  
)

export default component.exports